<template>
  <OrganismLogin/>
</template>

<script>
export default {
  name: 'Login',

  components: {
    OrganismLogin: () => import('@/components/organisms/OrganismLogin')
  },

  mounted () {
    if (!this.$route.params.id) {
      window.location.replace('https://vidroop.com')
    } else {
      localStorage.setItem('academy_param', this.$route.params.id)
    }
  }
}
</script>
